import VerificationInfo from './VerificationInfo';

export default VerificationInfo;
